/** @jsxImportSource @emotion/react */
import { memo } from "react";

//css読み込み
import { cautionWrap, cautionImg, cautionLargeText } from "assets/css/stylesCss";

// 解像度別に画像を用意
import small from "assets/img/caution/badgeUI_caution_large.png";
import medium from "assets/img/caution/badgeUI_caution_large@2x.png";
import large from "assets/img/caution/badgeUI_caution_large@3x.png";

/**
 * 赤いラージ注意文
 * childrenには要素内の文字列が自動的に入る
 */
const cautionLargeRed = memo(({ children }) => {
  return (
    <div css={cautionWrap} style={{ marginTop: "24px" }}>
      <img
        css={cautionImg}
        src={small}
        srcSet={`${small} 1x, ${medium} 2x, ${large} 3x`}
        alt="赤い大きい注意アイコン"
      />
      <p css={cautionLargeText}>{children}</p>
    </div>
  );
});

export default cautionLargeRed;
